import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../../../utils/api';

// Create an API thunk for fetching data
export const fetchJobRunDetails = createApi('jobRunDetails', 'GET');

const JobRunDetails = createSlice({
  name: 'JobRunDetails',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchJobRunDetails.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchJobRunDetails.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchJobRunDetails.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export default JobRunDetails.reducer;